/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getMABAA050, getPAJAC020CodeListPublic, getPAJAC020TaskManager } from '../../../services/Api';
import ResumePage from '../../../shared/components/ResumePage';
import {
    formatHomeUrl,
    formatNumberWithCommas,
    ImageCheckFallback,
    parseResumeActiveInfo,
    parseResumeCareerInfo,
    parseResumeLicenseInfo,
    parseResumeSchoolInfo,
} from '../../../utils';

const MABAA050 = () => {
    const printRef = useRef();
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [resumeSchoolInfo, setResumeSchoolInfo] = useState([]);
    const [resumeCareerInfo, setResumeCareerInfo] = useState([]);
    const [resumeLicenseInfo, setResumeLicenseInfo] = useState([]);
    const [resumeActiveInfo, setResumeActiveInfo] = useState([]);
    const codeLists = {
        A11: [],
        A14: [],
        A12: [],
    };
    const listContact = [
        { key: 'tel', value: '일반전화' },
        { key: 'mob', value: '휴대폰' },
        { key: 'eml', value: '이메일' },
        { key: 'pps', value: '덴탈잡 쪽지' },
    ];

    const getContactMethod = (key) => {
        if (!key || typeof key !== 'string') {
            return '';
        }
        if (!key.includes(',')) {
            const contact = listContact.find((item) => item.key === key);
            return contact ? contact.value : '';
        }

        const list = key.split(',');
        const contacts = list.map((k) => {
            const contact = listContact.find((item) => item.key === k);
            return contact ? contact.value : '';
        });
        return contacts.filter(Boolean).join(', ');
    };

    const getListData = async () => {
        getPAJAC020TaskManager().then((res) => (codeLists.A11 = res.data));
        getPAJAC020CodeListPublic('A14,A12')
            .then(({ data }) => {
                codeLists.A14 = data?.A14;
                codeLists.A12 = data?.A12;
            })
            .catch((error) => console.log(error));
        await getMABAA050(id)
            .then(({ data }) => {
                setData({
                    ...data,
                    resumeClass: getCodeName(data?.resumeClass, 'A11'),
                    resumeLicense: getCodeName(data?.resumeLicense, 'A14'),
                    resumeForm: getCodeName(data?.resumeForm, 'A12'),
                    resumePosition: getResumePosition(data?.resumePosition),
                });

                setResumeCareerInfo(data.resumeCareerInfo !== '' ? parseResumeCareerInfo(data.resumeCareerInfo) : '');
                setResumeLicenseInfo(
                    data.resumeLicenseInfo !== '' ? parseResumeLicenseInfo(data.resumeLicenseInfo) : '',
                );
                setResumeSchoolInfo(data.resumeSchoolInfo !== '' ? parseResumeSchoolInfo(data.resumeSchoolInfo) : '');
                setResumeActiveInfo(data.resumeActiveInfo !== '' ? parseResumeActiveInfo(data.resumeActiveInfo) : '');
            })
            .catch((error) => console.log(error));
    };
    useEffect(() => {
        if (id) {
            getListData();
        }
    }, [id]);

    // Hàm getCodeName
    const getCodeName = (codes, key) => {
        const list = codeLists[key]; // Lấy danh sách tương ứng với key
        const transformed = (codes || '')?.replace(/_/g, ', ')?.split(',');
        // Nếu không tìm thấy danh sách cho key, trả về mảng null
        if (!list) {
            return Array.isArray(transformed) ? transformed?.map(() => null) : [null];
        }
        // Đảm bảo codes là mảng, nếu không thì chuyển thành mảng
        const codeArray = Array.isArray(transformed) ? transformed : [transformed];

        // Loại bỏ khoảng trắng thừa ở đầu và cuối của từng mã
        const trimmedCodes = codeArray?.map((code) => code?.trim());
        const findCode = trimmedCodes.map((codeOrName) => {
            // Tìm theo code
            let found = list.find((item) => item.code === codeOrName);
            if (found) return found.code;
            // Tìm theo codeName
            found = list.find((item) => item.codeName === codeOrName);
            if (found) return found.code;
            // Không tìm thấy
            return '';
        });

        // Tìm codeName tương ứng cho từng mã đã được trim
        return findCode
            ?.sort((a, b) => Number(a) - Number(b))
            ?.map((code) => {
                const item = list?.find((item) => item?.code === code);
                return item
                    ? `${item?.codeName}${code === findCode[findCode.length - 1] ? '' : ','} `
                    : `${code}${code === findCode[findCode.length - 1] ? '' : ', '}`;
            });
    };
    const listResumePosition = [
        { codeName: '팀장', code: '001' },
        { codeName: '실장', code: '002' },
        { codeName: '스탭', code: '003' },
        { codeName: '무관', code: '999' },
    ];
    const getResumePosition = (value) => {
        const transformed = (value || '')?.replace(/_/g, ', ')?.split(',');
        // Nếu không tìm thấy danh sách cho key, trả về mảng null
        if (!listResumePosition) {
            return Array.isArray(transformed) ? transformed?.map(() => null) : [null];
        }
        // Đảm bảo codes là mảng, nếu không thì chuyển thành mảng
        const codeArray = Array.isArray(transformed) ? transformed : [transformed];

        // Loại bỏ khoảng trắng thừa ở đầu và cuối của từng mã
        const trimmedCodes = codeArray?.map((code) => code?.trim());
        const findCode = trimmedCodes.map((codeOrName) => {
            // Tìm theo code
            let found = listResumePosition.find((item) => item.code === codeOrName);
            if (found) return found.code;
            // Tìm theo codeName
            found = listResumePosition.find((item) => item.codeName === codeOrName);
            if (found) return found.code;
            // Không tìm thấy
            return '';
        });

        // Tìm codeName tương ứng cho từng mã đã được trim
        return findCode
            ?.sort((a, b) => Number(a) - Number(b))
            ?.map((code) => {
                const item = listResumePosition?.find((item) => item?.code === code);
                return item
                    ? `${item?.codeName}${code === findCode[findCode.length - 1] ? '' : ','} `
                    : `${code}${code === findCode[findCode.length - 1] ? '' : ', '}`;
            });
    };

    return (
        <div className="profile-content">
            <div className="rsm-prv active" id="resumePreview">
                <div className="rsm-prv__inner" ref={printRef}>
                    <div className="rsm-prv__top">
                        <h3 style={{ textAlign: 'center', marginTop: '10px', fontSize: '28px' }}>{data?.title}</h3>
                        <div className="rsm-dtl">
                            <div className="resume__block">
                                <div className="rsm-dtl__grid" style={{ gap: '10px' }}>
                                    <ImageCheckFallback
                                        folderName={'resume_logo'}
                                        imgName={data?.resumeLogo}
                                        alt="avtar"
                                        classImg={'rsm-dtl__img'}
                                    />
                                    <table className="rsm-dtl__table rsm-dtl__table--top">
                                        <tbody>
                                            <tr>
                                                <th>이름</th>
                                                <td>{data?.nameKor}</td>
                                                <th>이메일</th>
                                                <td>{data?.email}</td>
                                            </tr>
                                            <tr>
                                                <th>전화번호</th>
                                                <td>{data?.telNo}</td>
                                                <th>핸드폰</th>
                                                <td>{data?.mobileNo}</td>
                                            </tr>
                                            <tr>
                                                <th>홈페이지</th>
                                                <td>
                                                    {formatHomeUrl(data?.homeUrl) ? (
                                                        <a
                                                            style={{ cursor: 'pointer' }}
                                                            href={formatHomeUrl(data?.homeUrl)}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {data?.homeUrl}
                                                        </a>
                                                    ) : (
                                                        <span>{data?.homeUrl}</span>
                                                    )}
                                                </td>
                                                <th>희망연락방법</th>
                                                <td colSpan={3}>{getContactMethod(data?.contactMethod)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="resume__tit-box">
                                <h4 className="resume__tit2">희망 근무요건</h4>
                            </div>
                            <div className="resume__block">
                                <table className="rsm-dtl__table">
                                    <tbody>
                                        <tr>
                                            <th>희망업무</th>
                                            <td>{data?.resumeClass}</td>
                                        </tr>
                                        <tr>
                                            <th>소지자격증</th>
                                            <td>{data?.resumeLicense}</td>
                                        </tr>
                                        <tr>
                                            <th>희망 근무형태</th>
                                            <td>{data?.resumeForm}</td>
                                        </tr>
                                        <tr>
                                            <th>희망 근무지역</th>
                                            <td>
                                                {[
                                                    { si: data.resumeRegionSi1, gu: data.resumeRegionGu1 },
                                                    { si: data.resumeRegionSi2, gu: data.resumeRegionGu2 },
                                                    { si: data.resumeRegionSi3, gu: data.resumeRegionGu3 },
                                                ]
                                                    .filter((item) => item.si && item.gu)
                                                    .map((item, index, array) => (
                                                        <React.Fragment key={index}>
                                                            {item.si} &gt; {item.gu}
                                                            {index < array.length - 1 && ', '}
                                                        </React.Fragment>
                                                    ))}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>희망급여</th>
                                            <td>
                                                {data?.resumePay === '직접입력'
                                                    ? formatNumberWithCommas(data?.resumePayEtc)
                                                    : data?.resumePay}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>희망직급</th>
                                            <td>{data?.resumePosition}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <ResumePage
                                data={data}
                                resumeSchoolInfo={resumeSchoolInfo}
                                resumeCareerInfo={resumeCareerInfo}
                                resumeLicenseInfo={resumeLicenseInfo}
                                resumeActiveInfo={resumeActiveInfo}
                                desiredWorkingConditions={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MABAA050;
